
document.addEventListener('DOMContentLoaded', function() {
  const productQuickAdd = document.querySelector('.product-quick-add');
  
  if (productQuickAdd) {
    // Výchozí prahová hodnota pro všechny stránky
    let scrollPercentage = 20; // Show after scrolling 20% of page

    // Pokud je to produktová stránka 'snowfeet-pro-mini-ski-skates', změníme prahovou hodnotu
    if (window.location.pathname.includes('/products/snowfeet-pro-mini-ski-skates')) {
      scrollPercentage = 10; // Změníme na 5% pro tuto stránku
    }

    window.addEventListener('scroll', function() {
      // Výpočet pozice při scrollování
      const scrollPosition = window.scrollY;
      const pageHeight = document.body.scrollHeight - window.innerHeight;
      const hasScrolledPastThreshold = (scrollPosition / pageHeight) * 100 > scrollPercentage;
      
      if (hasScrolledPastThreshold) {
        productQuickAdd.classList.add('is-visible');
      } else {
        productQuickAdd.classList.remove('is-visible');
      }
    });
  }
});